export default __webpack_public_path__ + "static/media/client_search.6bbacb68.svg";